//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

/**
 * A random id that is generated and used only in the Pinterest Post Details
 * infrastrucuture to maintain a noramlized list of pins.
 *
 * Exists only in frontend.
 */
type PinId = Opaque<string, 'PinId'>;

function PinIdFactory(pinId: string) {
  return pinId as PinId;
}

const PinId = PinIdFactory;

export default PinId;
